<div class="card-body">
    <h4>Add Materials</h4>
    <!-- <button mat-button color="success" (click)="addAllMaterials()">
<mat-icon class="mr">add</mat-icon>Add All Materials
</button>  -->
 


<br> 
<input type="text" (keyup)="applyFilter($event)" placeholder="Search" />
 
<table class="table table-striped table-sm">
 
 
    <thead>
      <tr>
        <!-- <th>MaterialsID</th> -->
 
        <th><a (click)="sortBy('productName')"> Name{{sortIcon('productName')}}</a></th>
      <th *ngIf="isMobile"><a (click)="sortBy('productCategory')">Category{{sortIcon('productCategory')}}</a></th>
        <th *ngIf="isMobile"><a (click)="sortBy('subCategory')">Category{{sortIcon('subCategory')}}</a></th> 
        <th *ngIf="isMobile"><a (click)="sortBy('productDescription')">Description{{sortIcon('productDescription')}}</a></th>
        <th ><a (click)="sortBy('productPrice')"> Price{{sortIcon('productPrice')}}</a></th>
        <th *ngIf="isMobile"><a (click)="sortBy('productWeight')">Weight{{sortIcon('productWeight')}}</a></th>
        <th *ngIf="isMobile"><a (click)="sortBy('units')">Units{{sortIcon('units')}}</a></th>
        <!-- <th><a (click)="sortBy('total')">Total{{sortIcon('total')}}</a></th> -->
        <th></th>
      </tr>
    </thead>
    <tbody> 

      <tr *ngFor="let material of filteredData">
        <!-- <td>{{ material.materialsID }}</td> -->
        <td>{{ material.productName }}</td>
        <td *ngIf="isMobile">{{ material.productCategory }}</td>
        <td *ngIf="isMobile">{{ material.subCategory }}</td> 
        <td *ngIf="isMobile">{{ material.productDescription }}</td>
        <td >{{ material.productPrice }}</td>
        <td *ngIf="isMobile">{{ material.productWeight }}</td>
        <td *ngIf="isMobile">{{ material.units }}</td>
        <!-- <td>{{ material.total }}</td> -->
        <td>
          
          <a mat-fab class="custom-fab" (click)="addMaterialToProjectMaterials(material)"><mat-icon>add</mat-icon></a>
        </td>
      </tr>
    </tbody>
  </table>
  </div> 